import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {translateUppercase} from "@stefanholzapfel/lit-translate/dist/translateUppercase.directive";
import {getIcon} from "../../styles/icons";

@customElement('sp-id-brand')
export class SpIdBrand extends LitElement {
    @property({type: String}) version: string | number;
    static get styles() {
        // language=CSS
        return css`
            .container {
                display: flex;
                flex-direction: row;
                align-items: center;
                column-gap: 0.5ch;
            }
            
            sp-image {
                display: block;
                width: 1rem;
                height: 1rem;
            }
            
            .spotteron {
                font-family: 'EkMukta-SemiBold';
            }
        `;
    }

    protected render() {
        return html`
            <div class="container">
                <sp-image .image=${ getIcon('spotteron', { color: 'colored', size: 'x256' }) }></sp-image>
                <span class="spotteron">${ translateUppercase('UI_COMPONENT_SPOTTERON_BRAND') }</span> 
                <span class="id">${ translateUppercase('UI_COMPONENT_ID_BRAND') }</span>
            </div>
        `;
    }
}
